import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
import { CHECKOUT_URL } from '../data/offer';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(84455);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-244" data-mp="evefa45qf5yx">
      {visible && <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-ink/95 backdrop-blur" data-id="element-245" data-mp="ewpjg533afqk">
          <div className="mx-auto flex max-w-content items-center justify-between gap-3 px-4 py-3 sm:px-8" data-id="element-246" data-mp="248rnw5kvng5u">
            <div className="min-w-0" data-id="element-247" data-mp="3ihd3hj0my1d3">
              <p className="truncate text-xs font-bold text-ivory sm:text-sm" data-id="element-248" data-mp="3mgua4frst4ju">
                MegaPack Reconexión · $19.990 ARS
              </p>
              <p className="text-[11px] text-muted sm:text-xs" data-id="element-249" data-mp="38inmrtkh6myf">
                Cierra en{' '}
                <span className="tabular-nums font-semibold text-accent" data-id="element-250" data-mp="3dg5u5fiugu4b">
                  {hours}:{minutes}:{seconds}
                </span>
              </p>
            </div>
            <a href={CHECKOUT_URL} className="cta-breathe shrink-0 rounded-xl bg-accent px-4 py-3 text-xs font-extrabold text-accentInk transition-[background-color] duration-150 ease-soft hover:bg-[#ffbd53] sm:px-5 sm:text-sm" data-id="element-251" data-mp="9xvso2t1bzg9">
              QUIERO MI MEGAPACK
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}